

import { gridSize, } from "@/shared";
import { useFetchPaymentMethodsParamsProveedor } from "@/shared/actions/erp";
import { CustomAutocompleteMultipleArrString } from "@/shared/components/ui";
import CustomGroupButton from "@/shared/components/ui/CustomGroupButtom";
import CustomInputMetodoPago from "@/shared/components/ui/CustomInputMetodoPago";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs"
import { AlertSeverityEnum } from "@/shared/interfaces";
import { IDataMetodoPago, useMetodoPago } from "@/store/erp";
import { useUiStore } from "@/store/ui";

import { Alert, Button, Grid, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";



type ModalMetodoPagoMixtoProps = {
  isModalPago: boolean
  setIsModalPago: (value: boolean) => void;
  valores: any;
  nombre?: string;
}
type SaveFormData = {
  forma_pago: string;
}


export const ModalMetodoPagoMixto = ({ isModalPago, setIsModalPago,
  valores,
  nombre
}: ModalMetodoPagoMixtoProps) => {

  //store
  const setAlert = useUiStore(s => s.setAlert)
  const handleMetodoPagoLista = useMetodoPago(s => s.handleMetodoPagoLista)


  ///state:
  const [selectedOptions, setSelectedOptios] = useState<string[]>([])
  const [porcentajes, setPorcentajes] = useState<Record<string, number>>({})


  const { data: formaPagoPaging, isLoading: isLoadingFormaPagoPaging } =
    useFetchPaymentMethodsParamsProveedor({ page_size: 600 });

  const form = useForm<SaveFormData>({});
  const [value, setValue] = useState(1)

  //
  const handleButtonClick = (value: number) => {
    setValue(value)
  }

  //hook
  const {
    formState: { errors },
  } = form;
  //**
  const handlePorcentaje = (metodo: string, value: string) => {

    const numero = parseFloat(value)
    setPorcentajes((actual) => ({ ...actual, [metodo]: isNaN(numero) ? 0 : numero }))
  }

  const totalPorcentaje = Object.values(porcentajes).reduce((acumulador, valor) => acumulador + valor, 0)

  //funcion
  const calcularTotal = () => {
    if (value === 1) {
      return (totalPorcentaje / 100) * valores;
    } else if (value === 2) {
      return (totalPorcentaje)
    }
    return 0
  }
  const calcularMontoPorMetodo = (): Record<string, number> => {
    const resultado: Record<string, number> = {}
    for (const metodo of selectedOptions) {
      const valor = porcentajes[metodo] ?? 0;
      if (value === 1) {
        const calculo = (valor / 100) * valores;
        resultado[metodo] = parseFloat(calculo.toFixed(2))
      } else if (value === 2) {
        resultado[metodo] = parseFloat(valor.toFixed(2))
      }
    }
    return (resultado);
  }
  ///limpiar 
  useEffect(() => {
    if (value === 1 && totalPorcentaje > 100) {
      setPorcentajes({})
      setAlert(true, 'La suma de los porcentajes no debe ser mayor a " 100 ".', AlertSeverityEnum.error)
    }
    if (value == 2 && totalPorcentaje > valores) {
      setPorcentajes({})
      setAlert(true, 'La suma de la cantidad no debe ser mayor a " subtotal ".', AlertSeverityEnum.error)
    }

  }, [totalPorcentaje])
  //limpia cuando % o $
  useEffect(() => {
    if (value) {
      setPorcentajes({})
    }
  }, [value])

  //onsave
  const onSave = () => {

    const campoValido = selectedOptions.filter(metodo => !porcentajes[metodo] || porcentajes[metodo] <= 0)

    if (campoValido.length > 0) {
      setAlert(
        true,
        ` Falta asignar porcentaje a: ${campoValido.join(', ')}. Divida el 100% entre todas.`,
        AlertSeverityEnum.error
      );
      return
    }
    const calculos = calcularMontoPorMetodo()

    const aux: IDataMetodoPago[] = Object.entries(calculos).map(([metodo, valor]) => ({
      metodo,
      valor: valor.toFixed(2)
    }))
    handleMetodoPagoLista(aux)
    setIsModalPago(false)
  }
  //
  useEffect(() => {
    if (!nombre) {
      setSelectedOptios([])
      setPorcentajes({})
    }
  }, [nombre])
  //
  return (
    <>
      <ScrollableDialogProps
        open={isModalPago}
        title="Configuración de Pago Mixto "
        onCloseIcon={() => setIsModalPago(false)}
        minWidth="50%"
        contentNode={
          <>

            <Grid container spacing={2}>
              {valores > 0 && (
                <>
                  <Grid item xs={12} mt={1}>
                    <Typography>{'Seleccione al menos 2 formas de pago.'}</Typography>

                  </Grid>

                  <Grid item xs={12} mt={2}>
                    <CustomAutocompleteMultipleArrString
                      label="Método Pago"
                      name="forma_pago"
                      options={formaPagoPaging?.data.data.filter(item => item.nombre !== 'MIXTO').map(item => item.nombre) || []}
                      isLoadingData={isLoadingFormaPagoPaging}
                      defaultValue={selectedOptions}
                      helperText={errors.forma_pago?.message}
                      textFieldKey='forma_pago'
                      enableStringify={false}
                      onChangeValue={(value: string | string[]) => {
                        setSelectedOptios(Array.isArray(value) ? value : [value])
                      }}
                    />
                  </Grid>
                </>


              )}


              {valores === 0 && (
                <Grid item {...gridSize} mt={3}>
                  <Alert variant="outlined" severity="info">
                    {'Lea detenidamente las siguientes instrucciones: Este método de pago se habilitará únicamente después de que incluya la solicitud de compra y asigne el valor unitario a cada producto. '}
                  </Alert>
                </Grid>

              )}

              {valores > 0 &&
                selectedOptions.length === 1 && (
                  <Grid item {...gridSize}>
                    <Alert variant="outlined" severity="info">
                      {'Selecciona al menos una opción más para continuar con los siguientes pasos. '}

                    </Alert>
                  </Grid>

                )
              }

              {(valores > 0 && selectedOptions.length > 1 && (
                <>
                  <Grid item xs={12}>
                    <Typography fontWeight={'bold'}>{'Tipo de valor'}</Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <CustomGroupButton
                      handleButtonClick={handleButtonClick}
                      activeButton={value}
                      buttonSize="small"
                      titleBtnTextPrimary="Porcentaje(%)"
                      titleBtnTextSecondary="Cantidad ($)"
                    >
                      {([1, 2].includes(value)) && selectedOptions.length > 1 && (
                        <Grid container spacing={3}>
                          {selectedOptions.map((metodo) => (
                            <CustomInputMetodoPago
                              key={metodo}
                              metodo={metodo}
                              value={porcentajes[metodo] ?? ''}
                              onChange={handlePorcentaje}
                              modo={value === 1 ? 'porcentaje' : 'cantidad'}
                            />
                          ))}

                        </Grid>
                      )}
                    </CustomGroupButton>

                  </Grid>

                  <Grid item xs={12}>
                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                      <Typography variant="subtitle1">{value === 1 ? 'Total de Porcentaje:' : 'Total Cantidad'}</Typography>
                      <Typography variant="subtitle1" color={(value === 1 && totalPorcentaje === 100) || (value === 2 && totalPorcentaje === valores) ? 'green' : 'error'}>
                        {totalPorcentaje}{value === 1 ? '%' : value === 2 ? '$' : ''}
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid item xs={12} justifyItems={'flex-end'}>
                    <Typography fontWeight={'bold'}>{`SubTotal: $${valores}`}</Typography>

                  </Grid>


                  <Grid item xs={12}>
                    <Grid container justifyContent={'space-between'} alignItems={'center'}>
                      <Typography variant="subtitle1">
                        {value === 1 ? 'Saldo restante en porcentaje:' : 'Saldo restante:'}
                      </Typography>
                      <Typography variant="subtitle1">
                        {`${Math.abs(
                          value === 1
                            ? (totalPorcentaje - 100)
                            : (totalPorcentaje - valores)
                        ).toFixed(2)} `}
                        {value === 1 ? '%' : value === 2 ? '$' : ''}
                      </Typography>

                      {/* <Typography variant="subtitle1">
                        {`${Math.abs(value === 1 ? Math.trunc((totalPorcentaje - 100)*100)/100 
                          : Math.trunc((totalPorcentaje - valores)*100)/100).toFixed(2)} `}
                        {value === 1 ? '%' : value === 2 ? '$' : ''}
                      </Typography> */}

                    </Grid>
                  </Grid>

                  {totalPorcentaje !== 100 && value == 1 && (
                    <Grid item xs={12}>
                      <Typography>
                        {`El total de porcentaje debe sumar exactamente 100%. Actualmente suma ${totalPorcentaje} %`}
                      </Typography>

                    </Grid>

                  )}

                  {totalPorcentaje !== valores && value === 2 && (
                    <Grid item xs={12}>
                      <Typography>
                        {`El total de cantidad debe sumar exactamente $${valores}. Actualmente suma ${totalPorcentaje} $`}
                      </Typography>
                    </Grid>

                  )}

                  {
                    value === 1 && totalPorcentaje === 100 && (
                      <Grid item xs={12}>
                        <Typography variant="h6" fontWeight={'bold'}>{'Detalle de montos por método de pago'}</Typography>
                        {Object.entries(calcularMontoPorMetodo()).map(([metodo, monto]) => (
                          <Typography key={metodo} mt={1}>
                            <strong>{metodo}:</strong> ${monto.toFixed(2)}
                          </Typography>
                        ))}

                      </Grid>
                    )
                  }



                  {
                    value === 1 && totalPorcentaje === 100 && (
                      <Grid item xs={12} justifyItems={'flex-end'}>
                        <Typography fontWeight={'bold'} >
                          Monto Calculado:
                          <span > $ {calcularTotal().toFixed(2)}</span>
                        </Typography>
                      </Grid>
                    )
                  }



                </>


              ))}

            </Grid>

            {valores > 0 && selectedOptions.length > 1 && ((value === 1 && totalPorcentaje === 100) ||
              totalPorcentaje === valores
            ) && (
                <Grid item xs={12} container justifyContent="flex-end" mt={2}>
                  <Button
                    variant="outlined"
                    color="success"
                    onClick={onSave}
                  >
                    {'Guardar'}
                  </Button>
                </Grid>
              )
            }



          </>

        }
      />


    </>
  )
}
export default ModalMetodoPagoMixto